import { render, staticRenderFns } from "./PatientNewView.vue?vue&type=template&id=41c83a05&"
import script from "./PatientNewView.vue?vue&type=script&lang=ts&"
export * from "./PatientNewView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports